import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

/** Single headline number with a label and optional sub-line. */
const KpiTile = ({ label, value, sub, color }) => (
  <Card variant="outlined" sx={{ height: '100%' }}>
    <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
      <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.3 }}>{value}</Typography>
        {color && <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color }} />}
      </Box>
      {sub && <Typography variant="caption" color="text.secondary">{sub}</Typography>}
    </CardContent>
  </Card>
);

export default KpiTile;
